import { useEffect, useState } from 'react';
import { Activity, RefreshCw } from 'lucide-react';
import apiService from '../services/api';
import SystemHealthCards from './SystemHealthCards';

export default function AnalyticsSystemSection() {
  const [health, setHealth] = useState(null);
  const [clientLatency, setClientLatency] = useState(null);
  const [checkedAt, setCheckedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const start = Date.now();
      const data = await apiService.getHealthStatus();
      setClientLatency(Date.now() - start);
      setHealth(data);
      setCheckedAt(new Date());
    } catch (err) {
      setError(err.message || 'Impossible de charger la santé système');
      setHealth(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div id="analytics-section-system" className="card border-2 border-blue-100 scroll-mt-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
          <Activity className="h-6 w-6 text-blue-600" />
          Santé du système
        </h2>
        <button
          type="button"
          onClick={load}
          disabled={loading}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          Actualiser
        </button>
      </div>

      {error && (
        <p className="text-sm text-red-600 mb-4" role="alert">
          {error}
        </p>
      )}

      {loading && !health ? (
        <p className="text-gray-500 text-sm">Chargement…</p>
      ) : (
        <>
          <SystemHealthCards
            health={health}
            clientLatency={clientLatency}
            checkedAt={checkedAt}
          />
          {health && (
            <div className="mt-4 text-sm text-gray-600 bg-gray-50 rounded-lg p-4 border border-gray-200">
              <p>
                <span className="font-medium">Dernière vérification :</span>{' '}
                {health.timestamp
                  ? new Date(health.timestamp).toLocaleString('fr-FR')
                  : '—'}
              </p>
              {health.nodeVersion && (
                <p className="mt-1">
                  <span className="font-medium">Runtime :</span> {health.nodeVersion}
                </p>
              )}
              <p className="mt-2 text-xs text-gray-500">
                Endpoint : <code className="bg-gray-100 px-1 rounded">GET /api/health</code>
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
